import React from 'react'
import { useStore } from '../../../../../lib/context';
import { observer } from 'mobx-react-lite';
import LeftArrow from '../../../Icons/LeftArrow';
import RightArrow from '../../../Icons/RightArrow';

const NavModuleSEarchTagsCarouselControls = observer(({data}) => {
    const {articleQueryStore: {incrementTagPage, decrementTagPage, numTagPages, activeTagPageIdx}} = useStore();
    
    return (
        <div className="nav-module-search-tags-carousel-controls flex--center">
            <LeftArrow onClick={decrementTagPage}/>
            <div className="dots">
                {new Array(numTagPages).fill(0).map((_, idx) => {
                    return <div className={activeTagPageIdx === idx ? "dot active" : "dot"} key={`nmstcc-${idx}`}></div>
                })}
            </div>
            <RightArrow onClick={incrementTagPage}/>
            <style jsx>{`
                .dot {
                    width: 8px;
                    height: 8px;
                    border-radius: 50%;
                    background: rgba(230,230, 230, .6);
                    transition: background .2s ease;
                }
                .active {
                    background: white;
                }

                .nav-module-search-tags-carousel-controls :global(svg) {
                    height: 32px;
                    cursor: pointer;
                }

                .nav-module-search-tags-carousel-controls :global(svg circle) {
                   transition: opacity .2s ease;
                }

                .nav-module-search-tags-carousel-controls :global(svg:hover circle) {
                    opacity: 1;
                }

                .dots {
                    display: grid;
                    grid-template-columns: repeat(${numTagPages}, 1fr);
                    grid-gap: 6px;
                    align-items: center;
                    margin: 0 12px;
                }
            `}</style>
        </div>
    )
})

export default NavModuleSEarchTagsCarouselControls